import { useEffect, useState } from 'react';
import LogoRef from '../../../assets/img/logoRef.png';
import { enumUtil } from '../../../utils/Enum';
import NotificationHandler from '../../../utils/NotificationHandler';
import { ServerRequestProtected, ServerRequestProtectedOCR, ServerRequestPublic } from '../../../utils/ServerDataRequest';
import handleAlphabeticCheck from '../../../utils/HandleAlphabetKeys';
import FormValidator from '../../../utils/FormValidator';
import isNull from '../../../utils/NullChecking';
import Loader from '../../shared/Loader/Loader';
import handleNumericCheck from '../../../utils/HandleNumericKeys';
import SignEncounter from '../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/Components/SignEncounter';
import { formatFax } from '../../../utils/Formatting';
import FormatPhoneNumber from '../../../utils/FormatPhoneNumber';
const CreditCardAuthorization = ({ ID, InsuranceDD, PracticeInfo, PatientName, data, PatientID, IsSubmitted, isDeleted, IsDefaultSignature, DefaultSignaturePath }) => {
    const API_URL = enumUtil.controller.Patient
    let Card_Modal = {
        name: '',
        PatientID: '',
        Agreement: false,
        OTP: ''
    }
    let valModal = {}
    let ValidationModal = {
        NameVal: '',
        AgreementVal: '',
        SignaturePath: "",
        OTP: ""
    }
    const [validationErrors, setValidationErrors] = useState(ValidationModal)
    const [isLoading, setIsLoading] = useState(false);
    const [paymentLink, setPaymentLink] = useState(data)
    const [cardDetails, setCardDetails] = useState(Card_Modal);
    const [isSign, setIsSign] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(IsSubmitted === "true" ? true : false);
    const [isFormSaved, setIsFormSaved] = useState(false);
    const [saveCardDetails, setSaveCardDetails] = useState({});
    const [hasDefaultSignature, setHasDefaultSignature] = useState(IsDefaultSignature);
    const [signatureData, setSignatureData] = useState({
        SignatureFileName: '',
        SignaturePath: ''
    })
    const handleCardChange = (e) => {
        let { name, value } = e.target;
        // Handle expiration date formatting
        if (name === 'expiry') {
            value = formatExpiryDate(value);
        }
        let modal = { ...cardDetails };
        let saveModal = { ...saveCardDetails }

        if (name === "Agreement") {
            modal[name] = !modal[name]
        } else {
            modal[name] = value;
        }
        setCardDetails(modal)
        for (var property in Card_Modal) {
            if (name === property) {
                if (name === "Agreement") {
                    saveModal[name] = modal[name] + ""
                } else {
                    saveModal[name] = value
                }
            }
        }
        setSaveCardDetails(saveModal)
    }
    const CCAValidation = async () => {

        const isSignatureValid = signatureData.SignaturePath || (hasDefaultSignature === 'true' && DefaultSignaturePath);

        let ValidationModal = {
            AgreementVal: FormValidator(
                cardDetails.Agreement,
                'Bool',
                'Authorization',
            ),
            OTP: FormValidator(
                cardDetails.OTP,
                enumUtil.enumValidationType.Required,
                'OTP',
            ),
            SignaturePath: isSignatureValid ? '' : FormValidator(
                signatureData.SignaturePath,
                enumUtil.enumValidationType.Required,
                'Signature',
            )
        }
        await setValidationErrors(ValidationModal)
        valModal = ValidationModal
    }
    const getSaveData = async (_, filename, base64, obj) => {
        let newData = {
            "SignatureFileName": filename,
            "SignaturePath": base64,
            "IsDefaultSignature": obj?.isDefaultSignature.toString()
        }
        setSignatureData(newData)

        // setCardDetails(prev => ({ ...prev, ...newData }))
        // setSaveCardDetails(prev => ({ ...prev, ...newData }))
    }
    const handleRemoveFile = () => {
        let newData = {
            "SignatureFileName": '',
            "SignaturePath": ''
        }
        setSignatureData(newData)
        setHasDefaultSignature('false')
        // setCardDetails(prev => ({ ...prev, ...newData }))
        // setSaveCardDetails(prev => ({ ...prev, ...newData }))
    }
    const formatExpiryDate = (input) => {
        let value = input.replace(/\D/g, '');
        if (value.length >= 2) {
            let month = value.substring(0, 2);
            if (parseInt(month) > 12) {
                month = '12';
            } else if (parseInt(month) < 1 && month.length === 2) {
                month = '01';
            }
            if (value.length > 2) {
                let year = value.substring(2, 4);
                value = month + '/' + year;
            } else {
                value = month;
            }
        }
        return value.substring(0, 5);
    };
    const [token, setToken] = useState(null);
    const generateIframeCss = () => {
        const cssObject = {
            body: {
                margin: '0',
                padding: '0',
                fontFamily: 'Poppins, sans-serif'
            },
            input: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8',
                borderRadius: '5px',
                color: '#434343',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '12px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: '100%',
                display: 'block',
                marginBottom: '10px'
            },
            'input:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright)',
                outline: 'none',
                backgroundColor: '#fff'
            },
            'input + br': {
                display: 'none'
            },
            select: {
                appearance: 'auto',
                border: '0.5px solid #D8D8D8',
                borderRadius: '5px',
                color: '#434343',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '12px',
                fontWeight: '400',
                height: '36px',
                padding: '2px 7px',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                width: 'calc(50% - 15px)',
                marginBottom: '10px',
                backgroundColor: '#fff',
            },
            'select:focus': {
                boxShadow: 'none',
                borderColor: 'var(--orangeBright)',
                outline: 'none'
            },
            '#ccexpiryyear': {
                marginLeft: '12px'
            },
            label: {
                fontSize: '13px',
                color: '#000000',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: '400',
                marginBottom: '3px'
            }
        };

        let cssString = '';
        for (const selector in cssObject) {
            cssString += selector + '{';
            for (const prop in cssObject[selector]) {
                const cssProp = prop.replace(/([A-Z])/g, '-$1').toLowerCase();
                cssString += cssProp + ':' + cssObject[selector][prop] + ';';
            }
            cssString += '}';
        }
        return encodeURIComponent(cssString);
    };
    const iframeUrl = `${paymentLink}?useexpiry=true&invalidexpiryevent=true&usecvv=true&invalidcvvevent=true&cardinputmaxlength=19&cardnumbernumericonly=true&formatinput=true&sendcardtypingevent=true&css=${generateIframeCss()}`;
    const handlePayNow = async () => {
        await CCAValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (isNull(token)) {
            NotificationHandler('Card information is missing', enumUtil.enumtoaster.error)
            return
        } else if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setIsLoading(true)
            let DefualtSignatureData = {};

            if (hasDefaultSignature === 'true') {
                DefualtSignatureData = {
                    'IsDefaultSignature': hasDefaultSignature,
                    'SignaturePath': DefaultSignaturePath
                };
            } else {
                DefualtSignatureData = {
                    'SignatureFileName': signatureData.SignatureFileName ? signatureData.SignatureFileName : '',
                    'SignaturePath': signatureData.SignaturePath ? signatureData.SignaturePath : '',
                    'IsDefaultSignature': signatureData.IsDefaultSignature ? signatureData.IsDefaultSignature : '',
                };
            }
            let data = {
                TableName: enumUtil.enumAPITableName.PatientIntakeCreditCard,
                Data: {
                    // PatientIntakeFormID: '0',
                    GuidID: ID,
                    PatientID: PatientID + "",
                    Agreement: saveCardDetails.Agreement,
                    Token: token,
                    CardHolderName: saveCardDetails.name,
                    OTP: saveCardDetails.OTP,
                    ...DefualtSignatureData,
                }
            }
            // let data = { ...saveCardDetails, PatientID: PatientID + "" }
            ServerRequestProtected(API_URL + '/SaveCreditCard', 'post', data).then((response) => {
                setIsFormSubmitted(true)
                setIsFormSaved(true)
                setIsLoading(false)
                NotificationHandler("Form submitted successfully", enumUtil.enumtoaster.success)
            }).catch((error) => {
                setIsLoading(false)
                setIsFormSubmitted(false)
                setIsFormSaved(false)
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            })
        }
    }
    useEffect(() => {
        if (!paymentLink) return;
        const handleMessage = (event) => {

            const baseOrigin = paymentLink.startsWith('http')
                ? new URL(paymentLink).origin
                : `https://${paymentLink}`;

            if (!event.origin.includes(baseOrigin)) return; // ✅ guard, not return UR

            try {
                const data = JSON.parse(event.data);
                if (data.cardTyping === true) {
                }
                if (data.message) {
                    setToken(data.message);
                } else {
                    // setToken('')
                    // setTokenizing(false); // hide loader
                }
            } catch (err) {
                console.error("Failed to parse token message", err);
            }
        };

        window.addEventListener("message", handleMessage, false);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [paymentLink, data?.paymentGateWayTokenizerURL]);

    const clearForm = () => {
        const clearedData = {
            ...Card_Modal,
            PatientIntakeFormID: '0'
        }
        setCardDetails(clearedData)
        setSaveCardDetails(clearedData)
        setValidationErrors({})
    }
    useEffect(() => {
        if (isDeleted === 'true') {
            NotificationHandler("This form has been deleted.", enumUtil.enumtoaster.error);
            return
        }
    }, [isDeleted])


    const [isSignImage, setIsSignImage] = useState(false);
    const loadSignatureFromServer = async (path) => {
        try {
            const response = await ServerRequestPublic(
                enumUtil.controller.Wasabi + "/DownloadFile",
                "post",
                { BucketPath: path },
                "Download"
            );

            if (
                response.type === "application/png" ||
                response.type === "application/jpg" ||
                response.type === "application/jpeg"
            ) {
                setIsSignImage(URL.createObjectURL(response));
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (hasDefaultSignature === 'true' && DefaultSignaturePath) {
            loadSignatureFromServer(DefaultSignaturePath);
        }
    }, [hasDefaultSignature === 'true', DefaultSignaturePath]);

    return (
        <>
            {isDeleted === 'true' ? null :
                <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                    {isLoading ? <Loader /> : null}
                    {isFormSubmitted ?
                        <div className="ar_fill-content-box d-flex flex-column">
                            <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                <div className="">
                                    <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                    <p className="text text-black fs-14"> {PracticeInfo?.PracticeAddress} <br />
                                        {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}</p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                        <p className='text text-black font-m fs-14'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                        <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white">
                                <p className="heading fs-16 lh-17 text-white form-heading">Credit Card Authorization</p>
                                {/* <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p> */}
                            </div>
                            <div className='sucsses_meessage d-flex align-items-center gap-20'>
                                <div>
                                    <i className='icon-tick-mark fs-49'></i>
                                </div>
                                <div >
                                    <p className='fs-22 text font-m green_Color'>
                                        {isFormSaved ? 'Form Submission Successful!' : 'This form is already submitted!'}
                                    </p>
                                    <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="ar_fill-content-box d-flex flex-column gap-16">
                            <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                <div className="">
                                    <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                </div>
                                <div className="text-center">
                                    <p className='heading text-black fs-16'>{PracticeInfo?.PracticeName}</p>

                                    <p className="text text-black fs-14">  {PracticeInfo?.PracticeAddress} <br />
                                        {PracticeInfo?.PracticeCity} ,  {PracticeInfo?.PracticeState},  {PracticeInfo?.PracticeZipCode}
                                    </p>

                                </div>
                                <div className="d-flex gap-10">
                                    <div className="">
                                        <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                        <p className='text text-black font-m fs-14'>Fax:</p>
                                    </div>
                                    <div className="">
                                        <p className='text text-black  pb-2px fs-14'>{FormatPhoneNumber(PracticeInfo?.PracticeTelephone)}</p>
                                        <p className='text text-black fs-14'>{formatFax(PracticeInfo?.PracticeFax)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white">
                                <p className="heading fs-16 lh-17 text-white form-heading">Credit Card Authorization</p>
                                <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                            </div>
                            <div className="ar_star-form-Preview">
                                <div className="Form-content d-flex flex-column gap-16 pe-1 hover-scrollbar ar_credit-card-fill-form">
                                    <div className="">
                                        <p className="heading fs-14 text-black mb-1">Credit Card Authorization</p>
                                        <p className="text text-black">Please complete all required fields below. By submitting this form, you authorize us to securely store your payment information and charge your card as described in this agreement.</p>
                                    </div>

                                    <div className="primary-insurance-content">
                                        <div className="content-box d-flex flex-column gap-10">
                                            {/* <div className="d-flex gap-10 align-items-center">
                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                        Card Holder Name <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-100'>
                                        <input type="text"
                                            className='form-control'
                                            name="SSN"
                                            id="SSN"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex gap-10">
                                    <p className='text fs-14 text-black min-w-156px d-flex justify-content-end gap-01'>
                                        Card Type <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='d-flex gap-4 flex-wrap row-gap-5'>
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                            <p className="text fs-14 text-black user-select-none">Visa</p>
                                        </label>
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                            <p className="text fs-14 text-black user-select-none">Master Card</p>
                                        </label>
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                            <p className="text fs-14 text-black user-select-none">Discover</p>
                                        </label>
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                            <p className="text fs-14 text-black user-select-none">American Express</p>
                                        </label>
                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                            <p className="text fs-14 text-black user-select-none">Other</p>
                                        </label>
                                    </div>
                                </div>

                                <div className="d-flex gap-10 align-items-center">
                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                        Card Number <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-100'>
                                        <input type="text"
                                            className='form-control'
                                            name="SSN"
                                            id="SSN"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex gap-10 align-items-center">
                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                        Expiration Date <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-100'>
                                        <input type="text"
                                            className='form-control'
                                            name="SSN"
                                            id="SSN"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="d-flex gap-10 align-items-center">
                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                        Security Code <span className="text font-m Denied-clr fs-14">*</span>
                                    </p>
                                    <div className='input w-100'>
                                        <input type="text"
                                            className='form-control'
                                            name="SSN"
                                            id="SSN"
                                            autoComplete="off"
                                        />
                                    </div>
                                </div> */}
                                            <div className='iframe-width' style={{ maxWidth: "450px" }}>
                                                {paymentLink && (
                                                    <iframe
                                                        id="tokenFrame"
                                                        name="tokenFrame"
                                                        // Query params to show expiry + CVV fields
                                                        src={iframeUrl}
                                                        frameBorder="0"
                                                        scrolling="no"
                                                        width="100%"
                                                        height="185"
                                                        title="CardPointe Payment Fields"
                                                    ></iframe>
                                                )}
                                                <div className="d-flex flex-column gap-10 mt-10">
                                                    <div className={"input mb-0"}>
                                                        {/* <div className={CardValidationModal.NameVal ? "input mb-0 error" : "input mb-0"}> */}
                                                        <label className='text-black fs-13 font-sans-serif'>Cardholder Name</label>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="name"
                                                            id="name"
                                                            value={cardDetails.name}
                                                            onChange={handleCardChange}
                                                            onKeyPress={handleAlphabeticCheck}
                                                        />
                                                        {/* {CardValidationModal.NameVal} */}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="">
                                        <p className="heading fs-14 text-black mb-1">Authorization <span className="text font-m Denied-clr fs-14">*</span></p>
                                        <label className="custom_check_box d-flex gap-6">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0 mt-1"
                                                name='Agreement'
                                                id='Agreement'
                                                checked={cardDetails.Agreement || false}
                                                onChange={handleCardChange}
                                            />
                                            <p className="text text-black user-select-none">I, <span className="heading text-black">{PatientName},</span> authorize <span className="heading text-black">{PracticeInfo.PracticeName}</span> to charge the credit card listed above for agreed-upon services, balances, copayments, deductibles, cancellation fees, and other charges related to my account. I understand that this authorization will remain in effect until the expiration of the credit card account. I may revoke this authorization at any time by contacting to the practice name. Revocation will not apply to charges already processed. I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                        </label>
                                    </div>
                                    {validationErrors.AgreementVal && <div className="invalid-feedback">{validationErrors.AgreementVal}</div>}

                                    <div className="content-box d-flex gap-10">
                                        <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                            Patient Signature<span className="text font-m Denied-clr fs-14">*</span>
                                        </p>
                                        {!isNull(signatureData.SignaturePath) || hasDefaultSignature === 'true' ?
                                            <div className="position-relative sign-here-box provider-sign-box cursor-pointer d-flex align-items-center justify-content-center h-100 py-4 px-2 w-100">
                                                <img
                                                    src={hasDefaultSignature === 'true' ? isSignImage : `data:image/png;base64,${signatureData.SignaturePath}`}
                                                    alt="Patient Signature"
                                                    style={{ maxHeight: '81px' }}
                                                />
                                                <span className="cross-icon d-flex" onClick={handleRemoveFile}>
                                                    <i className="icon-x-cros fs-14 dark-clr fw-900"></i>
                                                </span>
                                            </div> :
                                            <div className={`input w-100 ${validationErrors.SignaturePath ? 'error' : ''}`}>
                                                <div className={`form-control cursor-pointer d-flex align-items-center`} onClick={() => setIsSign(true)}>
                                                    <p className="text color-7070 select-none">
                                                        {cardDetails.SignatureFileName || 'Click to sign here'}
                                                    </p>
                                                </div>
                                                {validationErrors.SignaturePath && <div className="">{validationErrors.SignaturePath}</div>}
                                            </div>
                                        }
                                    </div>

                                    <div className="">
                                        <div className='ar_OTP-section d-flex flex-column gap-10'>
                                            <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                            <div className='px-2  content-box'>
                                                <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                                <div className={`input mb-0 w-50 ${validationErrors.SignaturePath ? 'error' : ''}`}>
                                                    <input
                                                        type="text"
                                                        className="form-control h-28 za_br_light"
                                                        name="OTP"
                                                        id="OTP"
                                                        autoComplete="off"
                                                        onChange={handleCardChange}
                                                        value={cardDetails.OTP || ''}
                                                        onKeyPress={(event) => handleNumericCheck(event)}
                                                    />
                                                    {validationErrors.OTP && <div className="">{validationErrors.OTP}</div>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                        <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handlePayNow} >Submit Form</button>
                                        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={clearForm}>Clear Form</button>
                                    </div>
                                </div>
                                <SignEncounter
                                    isSign={isSign}
                                    setIsSign={setIsSign}
                                    setSearchParam={() => { }}
                                    providerName={PatientName}
                                    isOpenedFrom={'PatientDefaultSignature'}
                                    getSaveData={getSaveData}
                                />

                            </div>
                        </div>
                    }
                </div>
            }</>
    )
}

export default CreditCardAuthorization